export const goToExternalUrl = (link: string) => {
  window.open(link, "_blank");
};

export const openDocumentInNewTab = (file: string) => {
  window.open(file, "_blank");
};
